<template>
  <TooltipProvider>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <ClientOnly>
      <Toaster />
    </ClientOnly>
  </TooltipProvider>
</template>

<script setup lang="ts">
// The TooltipProvider should be at the top level to provide tooltip context 
// for the entire application
</script>
